import React, { useState, useEffect, useRef } from 'react';
import { useProductos } from '../hooks/useProductos';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { routes } from '../helpers/Routes';

const PaymentForm = () => {


    const { orden, cart, getOrden } = useProductos();
    const { norden } = useParams();

    useEffect(() => {
        if (norden) {
            getOrden(norden);
        }
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!window.EpaycoCheckout) {
            console.error('EpaycoCheckout no está disponible');
            return;
        }

        const handler = ePayco.checkout.configure({
            key: `${import.meta.env.VITE_PUBLIC_KEY}`,
            test: false // Cambiar a false en producción,
        });

        let totalPagar = 0;

        let nameProductos = "";
        cart?.map((item, idx) => {
            if (item?.nombre) {
                nameProductos += `${item?.nombre}, `;
            }
        })


        const data = {
            //Parametros compra (obligatorio)
            name: `${orden?.norden}`,
            description: nameProductos,
            invoice: `${orden?.norden}`,
            currency: "cop",
            amount: `${orden?.total}`,
            tax_base: "0",
            tax: "0",
            tax_ico: "0",
            country: "co",
            lang: "en",

            //Onpage="false" - Standard="true"
            external: "false",
            extra1: "https://bicicletasjavacolombia.com/",
            //Atributos cliente
            name_billing: `${orden?.name}`,
            address_billing: `${orden?.description}`,
            type_doc_billing: "cc",
            mobilephone_billing: `${orden?.telephone}`,
            email_billing: ``,

            response: `${window.location.origin}${routes.paySucess}`,
        }

        handler.open(data).then((result) => {
            console.log(result)
        }).catch((error) => {
            console.log(error);
        });
    };

    return (
        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", maxWidth: 500, width: "100%", padding: 20, borderRadius: 10 }}>

            <button type="submit" style={{ width: "100%" }}>Pagar</button>
        </form>
    );
};

export default PaymentForm;